import { render, staticRenderFns } from "./PaymentPlanRevisionHistoryBanner.vue?vue&type=template&id=baba8eb2&scoped=true&"
import script from "./PaymentPlanRevisionHistoryBanner.vue?vue&type=script&lang=ts&"
export * from "./PaymentPlanRevisionHistoryBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentPlanRevisionHistoryBanner.vue?vue&type=style&index=0&id=baba8eb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baba8eb2",
  null
  
)

export default component.exports